import { render, staticRenderFns } from "./deviceBorrowRemind.vue?vue&type=template&id=7f2a0fec&scoped=true&"
import script from "./deviceBorrowRemind.vue?vue&type=script&lang=js&"
export * from "./deviceBorrowRemind.vue?vue&type=script&lang=js&"
import style0 from "./deviceBorrowRemind.vue?vue&type=style&index=0&id=7f2a0fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a0fec",
  null
  
)

export default component.exports